import { c as _c } from "react/compiler-runtime";
import { STORES_API } from 'modules/stores/api/stores-api';
import { StoreId, StoreInterface } from 'modules/stores/types/stores-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export const useStore = storeId => {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const t1 = `${STORES_API}/${storeId}`;
  let t2;
  if ($[1] !== t1) {
    t2 = [t1, RequestModuleEnum.MembershipLightCourse];
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data,
    mutate
  } = useControlledSwr(t2, fetcher, undefined, !!user && !!storeId);
  let t3;
  if ($[3] !== data || $[4] !== mutate) {
    t3 = {
      data,
      mutate
    };
    $[3] = data;
    $[4] = mutate;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};